import { render, staticRenderFns } from "./CoPost.vue?vue&type=template&id=7db7520b&scoped=true&"
import script from "./CoPost.vue?vue&type=script&lang=ts&"
export * from "./CoPost.vue?vue&type=script&lang=ts&"
import style0 from "./CoPost.vue?vue&type=style&index=0&id=7db7520b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db7520b",
  null
  
)

export default component.exports